import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { TimelineSectionFrame } from "web_myplann/NotificationCenter/Components/TimelineSectionFrame";
import { TimelineSectionV2Frame } from "web_myplann/NotificationCenter/Components/TimelineSectionV2Frame";
import type { TimelineSectionProps } from "web_myplann/NotificationCenter/Types/TimelineSectionProps";

export const TimelineSection: FC<TimelineSectionProps> = (props) => {
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? (
		<TimelineSectionV2Frame {...props} />
	) : (
		<TimelineSectionFrame {...props} />
	);
};
